import './App.css';
import LiveDataChart from './components/Charts/LiveData';
import UsageCharts from './components/Charts/UsageCharts';

function App() {
 

  return (
    <div className="">
      <header className="">
      </header>
        <h2>Encoder - Live data</h2>
        <LiveDataChart url={process.env.REACT_APP_URL}/>
        <UsageCharts url={process.env.REACT_APP_URL}/>
        <h2>Previewer - Live data</h2>
        <UsageCharts url={process.env.REACT_APP_PREVIEW_URL}/>
    </div>
  );
}

export default App;
